import React from 'react';
import { Circle, Rect, Arrow } from 'react-konva';
import { LineShape } from 'graphql/types';
import { Position } from 'types';

interface LinkShapeProps {
  color: string;
  type: LineShape;
  position: Position;
  rotation?: number;
  start?: Position;
  end?: Position;
}

export default function LinkShape({
  type,
  position,
  start,
  end,
  color,
}: LinkShapeProps) {
  const config = {
    width: 25,
    height: 25,
    fill: color,
    ...position,
  };
  const offset = 12.5;

  switch (type) {
    case LineShape.Square:
      return <Rect {...config} offsetY={offset} offsetX={offset} />;
    case LineShape.Circle:
      return <Circle {...config} radius={15} />;
    case LineShape.Arrow:
      return (
        <ArrowShape position={position} start={start} end={end} color={color} />
      );
    default:
      return null;
  }
}

export function ArrowShape({ start, end, position, color }) {
  if (start) {
    return (
      <Arrow
        //offsetX={-10}
        // offsetY={-10}
      
        points={[start.x, start.y, position.x, position.y]}
        pointerAtBeginning={false}
      
        fill={color}
        pointerLength={30}
        pointerWidth={30}
      />
    );
  }

  if (end) {
    return (
      <Arrow
        points={[end.x, end.y, position.x, position.y]}
        fill={color}
        pointerLength={30}
        pointerWidth={30}
      />
    );
  }

  return null;
}
